import axios from 'axios';
import Cookies from 'js-cookie';

// const port = prompt('포트 번호를 입력해주세요.');

const instance = axios.create({
  baseURL: `https://xadom-account-backend.onrender.com`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 요청 인터셉터
instance.interceptors.request.use(
  config => {
    const token = Cookies.get('AUTH_TOKEN');
    if (token) {
      // Authorization 헤더와 쿠키 모두 설정
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터
instance.interceptors.response.use(
  response => {                                                                                                               
    // 로그인 요청인 경우에만 토큰 처리
    if (response.config.url?.includes('/login')) {
      const token = response.data.data?.token;
      if (token) {
        // 쿠키에 저장
        Cookies.set('AUTH_TOKEN', token,
          {
            path: '/',
            domain: '.xadom.ai'
          }
        );
        // Authorization 헤더 업데이트
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }
    if (response.config.url?.includes('/logout') || response.config.url?.includes('/delete')) {
      // 로그아웃 시 쿠키 삭제
      Cookies.remove('AUTH_TOKEN', { path: '/', domain: '.xadom.ai' });
    }
    return response;
  },
  error => {
    // 400 에러는 콘솔에 출력하지 않음
    if (error.response?.status !== 400) {
      console.error('API Error:', error);
    }

    if (error.response?.status === 401) {
      Cookies.remove('AUTH_TOKEN');
    }

    return Promise.reject(error);
  }
);

export default instance; 
